import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import * as d3 from 'd3';

import UsaStateHovers from "../Map/UsaStateHovers";
import UsaStateBorders from "../Map/UsaStateBorders";

import '../Map/Map.css';
import './NationalSelector.css';
import NationalSelectorShapes from "./NationalSelectorShapes";

class NationalSelector extends Component {

  constructor(props) {
    super(props);

    this.state = {
      width: 500,
      height: 250
    };
  }

  componentDidMount() {
    this.handelResize(this.refs.wrapper.offsetWidth)
  }

  handelResize(width = 500) {
    this.setState({width: width, height: width * .57});
  }

  render() {
    return (
      <div ref="wrapper" className="NationalSelector" height={this.state.height}>
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <svg width={this.state.width} height={this.state.height}>
          <NationalSelectorShapes
            width={this.state.width}
            height={this.state.height}
            selected={this.props.selectedState}
          />
          <UsaStateHovers
            width={this.state.width}
            height={this.state.height}
            onHoverOver={ stateFips => {
              d3.selectAll("#FIPS_" + stateFips).attr("class", "hover_over");
            }}
            onHoverOut={stateFips => {
              d3.selectAll("#FIPS_" + stateFips).attr("class", "hover_out");
            }}
            onClick={stateFips => {
              if (this.props.onClick) {
                this.props.onClick(stateFips)
              }
            }}/>
          <UsaStateBorders width={this.state.width} height={this.state.height}/>
        </svg>
      </div>
    );
  }
}

NationalSelector.propTypes = {
  onClick: PropTypes.func,
  selectedState: PropTypes.number
};

export default NationalSelector;


// WEBPACK FOOTER //
// ./src/charts/NationalSelector/index.js